import { z } from 'zod';

/** Filtros das listas de pessoas na URL (constituição II.4). Valor estranho é ignorado. */
const texto = z.string().optional().catch(undefined);
const id = z.uuid().optional().catch(undefined);
const status = z.enum(['ativo', 'inativo']).optional().catch(undefined);

export const buscaDosAlunos = z.object({
  nome: texto,
  email: texto,
  telefone: texto,
  dieta: texto,
  objetivo: texto,
  status: status,
  cursor: texto,
  tags: texto,
  /** Atalho "Convidar aluno" do Início (spec 015). */
  novo: z.boolean().optional().catch(undefined),
});

export const buscaDaEquipe = z.object({
  nome: texto,
  email: texto,
  funcaoId: id,
  status: status,
  cursor: texto,
  tags: texto,
});
